import { Routes } from '@angular/router';

/**
 * Dev-only routes (design gallery). The production build swaps this file for
 * `dev.routes.production.ts` (angular.json → fileReplacements), so the gallery's code is not
 * merely unregistered in production — it is not built into the output at all.
 */
export const DEV_ROUTES: Routes = [
  {
    path: 'dev/ui',
    loadComponent: () => import('./ui-gallery.page').then((m) => m.UiGalleryPage)
  }
];
